import { audienceForReturnUrl, isPaidPlanId } from "@acruxsoft/platform-shared";

/**
 * If returnUrl points to a known app audience, returns the canonical audience
 * hostname to ask mintRedirectToken for. Native custom schemes (e.g. Android's
 * `acruxsoft-tvm://`) map to their app's canonical web host. Returns null for
 * non-allowlisted hosts or malformed URLs.
 *
 * Delegates to the shared app catalog so this can't drift from the allowlist
 * the backend enforces.
 */
export function returnUrlAudience(returnUrl: string): string | null {
  return audienceForReturnUrl(returnUrl);
}

const VALID_INTERVALS = ["monthly", "yearly"] as const;

export function calculateReturnUrl(opts: {
  explicitReturn: string | null;
  plan: string | null;
  interval: string | null;
}): string {
  if (opts.explicitReturn) return opts.explicitReturn;
  const planOk = !!opts.plan && isPaidPlanId(opts.plan);
  const intervalOk = opts.interval && (VALID_INTERVALS as readonly string[]).includes(opts.interval);
  if (planOk && intervalOk) {
    return `/checkout?plan=${opts.plan}&interval=${opts.interval}`;
  }
  return "/home";
}
